<template>
  <div id="chatMessagesFeedBack"
       style="background: rgba(0, 0, 0, 0.7) none repeat scroll 0 0;z-index: 999; position: fixed; top: 0px; left: 0px; height: 100%;width:100%; overflow: scroll">
    <div class="chat clearfix textAlignfb margin fblock blk-t">
      <div class="iconclose" id="feedbackClose" style="display:none;">
        <a href="javascript:closeIframe();" style="color:black;cursor:pointer;"></a>
      </div>
      <div class="icon-outer feedback-title" id="chatSuccessMessage"
           style="display:none;min-height:150px;text-align:center"></div>
      <div class="icon-outer" id="chatMessagesFeedBackDiv">
        <div class="feedback clearfix">
          <div style="text-align:center">
            <strong id="feedbackHeading"
                    class="custom-pull-right-ar primary-font feedback-title">{{ labels['chatbox.FEEDBACK_POPUP_HEAD'] }}</strong>
          </div>
        </div>
        <div class="feedback clearfix">
          <div class=""></div>
        </div>
        <div id="feedbackSm" class="feedback clearfix txt-align-center"
             style="text-align: center; padding-left: 0px;padding-right: 27px; !important">
          <div id="touchHappy" class="icon-d nopadding feedbackfloat iconcenter" @click="feedbackYesEnter()">
            <img id="yes" @mouseover="feedbackYesOver" width="60" class="icon-gap icon-s" alt="User Avatar "
                 src="../assets/images/Happy2.png">
            <img style="display:none" id="yesleave" @mouseleave="feedbackYesLeave()" width="60" class=" icon-gap icon-s"
                 alt="User Avatar " src="../assets/images/HappyB2.png">
          </div>
          <div id="touchNeutral" class="icon-d nopadding feedbackfloat iconcenter" @click="feedbackNeutralEnter()">
            <img id="no" @mouseover="feedbackNeutralOver()" width="60" class=" icon-gap padding-btm-5 icon-s"
                 alt="User Avatar " src="../assets/images/Neutral2.png">
            <img style="display:none" id="neutralLeave" @mouseleave="feedbackNeutralLeave()" width="60"
                 class=" icon-gap padding-btm-5 icon-s" alt="User Avatar " src="../assets/images/NeutralB2.png">
          </div>
          <div id="touchUnHappy" class="icon-d nopadding feedbackfloat iconcenter" @click="feedbackUnhappyEnter()">
            <img id="q" @mouseover="feedbackUnhappyOver()" width="60" class="icon-gap icon-s" alt="User Avatar "
                 src="../assets/images/UnHappy2.png">
            <img style="display:none" id="unhappyLeave" @mouseleave="feedbackUnhappyLeave()" width="60"
                 class="icon-gap icon-s" alt="User Avatar " src="../assets/images/UnHappyB2.png">
          </div>
          <form @submit.prevent="submit" id="csatform" style="display:none">
            <ul id="chatMessages" class="form">
              <li class="left clearfix custom-background"  id="defaultskill">
                <div class="red-txt" id="complaintReasonError"  v-if="selectedComplaintReason ==''">{{ labels['chatbox.COMPLAINT_REASON_REQUIRED_ERROR_TEXT'] }}</div>
                <div class="left clearfix">
                  <v-select :options="complaintReasons" v-model="selectedComplaintReason"
                            :placeholher="selectComplaintReasonPlaceholder" :clearable="false" append-to-body></v-select>
                </div>
              </li>
              <li class="left clearfix custom-background">
                <div class="red-txt" id="complaintTextError" v-if="$v.complaintText.$error">
                  <div v-if="!$v.complaintText.required " :style="[lang=='ar' ? {'text-align': 'right'} : {'text-align': 'left'}]">{{ labels['chatbox.COMPLAINT_TEXT_REQUIRED_ERROR_TEXT'] }}</div>
                </div>
                <div class="left clearfix">
                  <app-text-area style="height: 75px" id="complaintText" v-model="complaintText" :status="$v.complaintText.$error ? 'error' : null"
                                 @blur.native="$v.complaintText.$touch()" :placeholder="enterComplaintTextPlaceholder"></app-text-area>
                </div>
              </li>
              <li class="left clearfix custom-background">
                <div class=" ">
                  <button :disabled="!isFormValid" type="submit" style="color:gray !important" id="submitButton"
                          class="btn  start-btn">{{ labels['chatbox.SEND_FEEDBACK_BUTTON_TEXT'] }}
                  </button>
                </div>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import WebChat from '../assets/js/chat/webChat'
import Vue from 'vue';
import http from "@/http-common";
import {required} from 'vuelidate/lib/validators';
import AppTextArea from './AppTextArea';

export default {
  name: "Feedback",
  components: {
    AppTextArea
  },
  data() {
    return {
      labels: Vue.prototype.$labels,
      /*happyOverImg: "",
      happyLeaveImg: "",
      neutralOverImg: "",
      neutralLeaveImg: "",
      unhappyOverImg: "",
      unhappyLeaveImg: "",*/
      selectComplaintReasonPlaceholder: "",
      enterComplaintTextPlaceholder: "",
      complaintReasons: [],
      complaintText: "",
      selectedComplaintReason: "",
      submitStatus: "",
      lang: this.$route.query.lang
    }
  },
  validations()
  {
    return {
      complaintText: {
        required
      },
    }
  },
  mounted() {
    this.labels = Vue.prototype.$labels
    /*this.happyOverImg = "../assets/images/" + this.labels['chatbox.ICONHAPPY']
    this.happyLeaveImg = "../assets/images/" + this.labels['chatbox.ICONHAPPYB']
    this.neutralOverImg = "../assets/images/" + this.labels['chatbox.ICONNEUTRAL']
    this.neutralLeaveImg = "../assets/images/" + this.labels['chatbox.ICONNEUTRALB']
    this.happyOunhappyOverImgverImg = "../assets/images/" + this.labels['chatbox.ICONUNHAPPY']
    this.unhappyLeaveImg = "../assets/images/" + this.labels['chatbox.ICONUNHAPPYB']*/
    this.selectComplaintReasonPlaceholder = this.labels['chatbox.SELECT_COMPLAINT_REASON']
    this.enterComplaintTextPlaceholder = this.labels['chatbox.ENTER_COMPLAINT_TEXT']
    this.customerId = ""
  },
  computed: {
    isFormValid() {
      let isValid = false;
      if(this.selectedComplaintReason !='' && this.selectedComplaintReason !=this.selectComplaintReasonPlaceholder && this.complaintText !='')
        isValid = true;

      return isValid;
    }
  },
  methods: {
    feedbackYesOver() {
      $("#yesleave").show();
      $("#yes").hide();
    },
    feedbackYesLeave() {
      $("#yesleave").hide();
      $("#yes").show();
    },
    feedbackYesEnter() {
      WebChat.customerFeedback.customerFeedback = "Happy"
      WebChat.isCreateJourney = true
      WebChat.redirect()
    },
    feedbackNeutralOver() {
      $("#neutralLeave").show();
      $("#no").hide();
    },
    feedbackNeutralLeave() {
      $("#neutralLeave").hide();
      $("#no").show();
    },
    feedbackNeutralEnter() {
      var yesElement = document.getElementById("yes");
      yesElement.classList.add("grayImage");
      var yesLeaveElement = document.getElementById("yesleave");
      yesLeaveElement.classList.add("grayImage");
      var unhappyLeaveElement = document.getElementById("unhappyLeave");
      unhappyLeaveElement.classList.add("grayImage");
      var qElement = document.getElementById("q");
      qElement.classList.add("grayImage");
      this.makeOptionsNotClickable();

      WebChat.customerFeedback.customerFeedback = "Neutral"
      WebChat.isCreateJourney = true
      this.showCSATForm();
    },
    feedbackUnhappyOver() {
      $("#unhappyLeave").show();
      $("#q").hide();
    },
    feedbackUnhappyLeave() {
      $("#unhappyLeave").hide();
      $("#q").show();
    },
    feedbackUnhappyEnter() {
      var yesElement = document.getElementById("yes");
      yesElement.classList.add("grayImage");
      var yesLeaveElement = document.getElementById("yesleave");
      yesLeaveElement.classList.add("grayImage");
      var neutralLeaveElement = document.getElementById("neutralLeave");
      neutralLeaveElement.classList.add("grayImage");
      var noElement = document.getElementById("no");
      noElement.classList.add("grayImage");

      this.makeOptionsNotClickable();

      WebChat.customerFeedback.customerFeedback = "Unhappy"
      WebChat.isCreateJourney = true
      this.showCSATForm();
    },
    showCSATForm() {
      $("#csatform").show();
      this.getComplaintReasons();
    },
    makeOptionsNotClickable() {
      var touchHappyElement = document.getElementById("touchHappy");
      touchHappyElement.classList.add("notClickable");
      var touchNeutralElement = document.getElementById("touchNeutral");
      touchNeutralElement.classList.add("notClickable");
      var touchUnHappyElement = document.getElementById("touchUnHappy");
      touchUnHappyElement.classList.add("notClickable");
    },
    getComplaintReasons() {
      http
          .get("/textCntsComplaintReason", {params:  {lang: this.lang, channel: Vue.prototype.$channel}})
          .then(response => {
            var complaintReasonDropboxLabelsList = response.data;
            var i = 0;
            for (i=0; i < complaintReasonDropboxLabelsList.length; i++) {
              this.complaintReasons[i] = complaintReasonDropboxLabelsList[i].textValue;
            }
            this.complaintReasons.unshift(this.selectComplaintReasonPlaceholder);
            this.selectedComplaintReason = this.complaintReasons[0];
          });
    },
    submit() {
      WebChat.customerFeedback.complaintReason = this.selectedComplaintReason;
      WebChat.customerFeedback.complaintText = this.complaintText;
      WebChat.redirect()
    }
  }
}
</script>
<style>
.form textarea::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #000000 !important;
  opacity: 1; /* Firefox */
}

.form textarea:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #000000 !important;
}

.form textarea::-ms-input-placeholder { /* Microsoft Edge */
  color: #000000 !important;
}

.grayImage {
  filter: gray; /* IE6-9 */
  -webkit-filter: grayscale(1); /* Google Chrome, Safari 6+ & Opera 15+ */
  filter: grayscale(1); /* Microsoft Edge and Firefox 35+ */
}
.notClickable {
  pointer-events: none
}

</style>
